import { render, staticRenderFns } from "./EwcSgi.vue?vue&type=template&id=b66c9b4c&scoped=true"
import script from "./EwcSgi.vue?vue&type=script&lang=js"
export * from "./EwcSgi.vue?vue&type=script&lang=js"
import style0 from "./EwcSgi.vue?vue&type=style&index=0&id=b66c9b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66c9b4c",
  null
  
)

export default component.exports